import router from '@/router';
import { getError } from '@/utils/helpers';
import AuthService from '@/services/AuthService';

export const namespaced = true;

export const state = {
  user: null,
  loading: false,
  error: null,
  confirmPassword: false
};

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_CONFIRM_PASSWORD(state, confirmPassword) {
    state.confirmPassword = confirmPassword;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export const actions = {
  logout({ commit, dispatch }) {
    return AuthService.logout()
      .then(() => {
        commit('SET_USER', null);
        dispatch('setGuest', { value: 'isGuest' });
        if (router.currentRoute.name !== 'login') router.push({ path: '/login' });
      })
      .catch(error => {
        commit('SET_ERROR', getError(error));
      });
  },
  async getAuthUser({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await AuthService.getAuthUser();
      commit('SET_USER', response.data.data);
      commit('SET_LOADING', false);
      return response.data.data;
    } catch (error) {
      commit('SET_LOADING', false);
      commit('SET_USER', null);
      commit('SET_ERROR', getError(error));
    }
  },
  setGuest(context, { value }) {
    window.localStorage.setItem('guest', value);
  },
  async confirmPasswordStatus({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await AuthService.confirmPasswordStatus();
      commit('SET_CONFIRM_PASSWORD', response.data.confirmed);
    } catch (error) {
      commit('SET_CONFIRM_PASSWORD', false);
      commit('SET_ERROR', getError(error));
    }
    commit('SET_LOADING', false);
  },
  async confirmPassword({ commit }, value) {
    commit('SET_LOADING', true);
    try {
      const response = await AuthService.confirmPassword(value);
      if (response) {
        commit('SET_CONFIRM_PASSWORD', true);
      }
    } catch (error) {
      commit('SET_CONFIRM_PASSWORD', false);
      commit('SET_ERROR', getError(error));
    }
    commit('SET_LOADING', false);
  }
};

export const getters = {
  authUser: state => {
    return state.user;
  },
  isAdmin: state => {
    return state.user ? state.user.isAdmin : false;
  },
  has2fa: state => {
    return state.user ? state.user.has_2fa : false;
  },
  error: state => {
    return state.error;
  },
  loading: state => {
    return state.loading;
  },
  loggedIn: state => {
    return !!state.user;
  },
  confirmPassword: state => {
    return state.confirmPassword;
  },
  guest: () => {
    const storageItem = window.localStorage.getItem('guest');
    if (!storageItem) return false;
    if (storageItem === 'isGuest') return true;
    if (storageItem === 'isNotGuest') return false;
  }
};
